"use client"

import { CaptionsOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CaptionsOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CaptionsOffIcon = component(Icon)({ as: CaptionsOff })
